/*
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnInit } from '@angular/core';
import { PermitAll } from '@csx/security';

@Component({
  selector: 'lms-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
@PermitAll()
export class AlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
